export default {
    methods: {
        getEncodedAddress(address) {
            return btoa(JSON.stringify({
                fullAddress: address.fullAddress,
                city: address.city,
                country: address.country,
                state: address.state,
                postalCode: address.postalCode,
                street: address.street,
                streetNumber: address.streetNumber,
                postDirection: address.postDirection || null,
                preDirection: address.preDirection || null,
                suffix: address.suffix || null,
                zip: address.zip,
                deliveryLine: address.deliveryLine,
                secondaryNumber: address.secondaryNumber
            }));
        },
    }
};
